import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
  age?: number;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  age
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-11">
      <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-12">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-13" />)}
      </div>
      <p className="text-gray-700 italic mb-6 text-lg" data-id="element-14">"{content}"</p>
      <div className="flex items-center gap-3" data-id="element-15">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-lg" data-id="element-16">
          {name.charAt(0)}
        </div>
        <div data-id="element-17">
          <h4 className="font-bold text-gray-900 leading-tight" data-id="element-18">{name}</h4>
          <p className="text-sm text-gray-500" data-id="element-19">
            {role}, {location}
          </p>
        </div>
      </div>
    </div>;
}